import { request } from './_request';
import {
  lastIndexUndefined,
  groupArrayOfObjects,
  undefinedIndexArrayToZero,
  averageArray,
} from '../helpers/ao';
import moment from 'moment';

export const getDataInventarioRDS = () => {
  return (dispatch, getState) => {
    const user = JSON.parse(localStorage.getItem('@@auth_user'));
    dispatch({
      type: 'SEARCH_DATA_INV',
    });

    request
      .get('/inventario_rds_mxl/data', {
        params: {},
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        let data = response.data;

        if (!data.error) {
          dispatch({
            type: 'READY_DATA_INV',
            payload: data.result,
          });
        } else {
          if (data.code == -1) {
            localStorage.removeItem('@@auth_user');
            dispatch({
              type: 'ERROR_TOKEN_INV',
              payload: { message: data.message, code: -1 },
            });
            dispatch({
              type: 'ERROR_TOKEN_INV',
              payload: data.message,
            });
          } else {
            dispatch({
              type: 'ERROR_INV',
              payload: data.message,
            });
          }
        }
      });
  };
};

export const downloadCsvData = () => {
  return (dispatch, getState) => {
    return new Promise((ready) => {
      let params = getState().inventarioRDSMxl;

      dispatch({ type: 'LOADING_REPORTS', payload: true });

      let nameCSV = 'Inventario RDS Mxli ';

      let headers = params.columnsData.map((a) => a.nombre);

      let indexGroup = params.columnsData.filter((item) => item.group === 1);

      let groupData = [];
      let values = [];
      values.push(headers);
      if (indexGroup.length == 1) {
        groupData = groupArrayOfObjects(params.data, indexGroup[0].index);

        for (let key in groupData) {
          let obj = groupData[key];

          let total = new Array(params.columnsData.length);
          let totalProm = new Array(params.columnsData.length);
          let index = 0;
          for (let i = 0; i < obj.length; i++) {
            let item = obj[i];
            let row = [];

            for (let j = 0; j < params.columnsData.length; j++) {
              let column = params.columnsData[j];
              row.push(item[column.index]);
              if (column.tipo === 'sumCurrency' || column.tipo === 'sum') {
                undefinedIndexArrayToZero(total, j);
                total[j] += item[column.index];
                undefinedIndexArrayToZero(totalProm, j);
                totalProm[j] += item[column.index];
                index = j;
              }
            }

            values.push(row);
          }
        }
      }

      dispatch({
        type: 'READY_CSV_DATA_REPORTS',
        payload: { name: nameCSV, data: values },
      });

      ready();
    });
  };
};
